// React imports
import React, { FunctionComponent } from 'react';

// UI Components
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';

// Utils
import { formatPromoCodeDate } from '../Utils';

// Styles
import styles from './PromoCodesUsageRow.module.scss';
import { Invoice } from '@spike/promocode-model';
import CustomButton from './CustomButton';

interface PromoCodesUsageRowProps {
    redeem: Invoice;
    isLast: boolean;
    isMobile: boolean;
    onViewBooking?: (bookingId: number, orderId: number) => void;
    onViewInvoice?: (invoice: Invoice) => void;
}

const PromoCodesUsageRow: FunctionComponent<PromoCodesUsageRowProps> = ({ redeem, onViewBooking, onViewInvoice }) => {
    const dateFormatted = formatPromoCodeDate(redeem.issuedAt);
    //const endDateFormatted = booking.endDate ? formatPromoCodeDate(booking.endDate) : null;

    return (
        <TableRow className={styles.desktopRow}>
            <TableCell>
                <p className={styles.promoNameUsage}>{redeem.customer.name}</p>
            </TableCell>

            <TableCell>
                <div className={styles.nameCell}>
                    {redeem.pets &&
                        redeem.pets.map(pet => (
                            <p
                                key={pet.id}
                                className={styles.promoDate}
                            >
                                {pet.name}
                            </p>
                        ))}
                </div>
            </TableCell>

            <TableCell>
                <div className={styles.nameCell}>
                    <p className={styles.promoDate}>{dateFormatted.date}</p>
                    <p className={styles.promoSubtitle}>{dateFormatted.time}</p>
                </div>
            </TableCell>

            <TableCell>
                <p>
                    {(() => {
                        const channel = redeem.booking?.channel ?? 'cuddles';
                        return channel.charAt(0).toUpperCase() + channel.slice(1);
                    })()}
                </p>
            </TableCell>
            <TableCell className={styles.redeemTotals}>
                <p>{`$${redeem.total}`}</p>
                <p className={styles.redeemSubtotal}>{`$${redeem.subtotal}`}</p>
            </TableCell>

            <TableCell isActions>
                {redeem.booking?.id ? (
                    <div className={styles.actionsContainer}>
                        <CustomButton
                            onAction={
                                onViewBooking ? () => onViewBooking!(redeem.booking!.id, redeem.orderid) : undefined
                            }
                            title="View Booking"
                        />
                    </div>
                ) : (
                    <CustomButton
                        onAction={onViewInvoice ? () => onViewInvoice!(redeem) : undefined}
                        title="View Invoice"
                    />
                )}
            </TableCell>
        </TableRow>
    );
};

export default PromoCodesUsageRow;
